import React from 'react';

const ServiceFilter = ({ categories, activeCategory, onCategoryChange }) => (
  <div className="flex flex-wrap gap-2 justify-center">
    <button
      onClick={() => onCategoryChange(null)}
      className={`px-6 py-2 rounded-full text-sm font-medium transition-all duration-300
        ${!activeCategory 
          ? 'bg-primary-500 text-white' 
          : 'bg-white/10 text-white hover:bg-white/20'
        }`}
    >
      Wszystkie
    </button>
    
    {categories.map((category) => (
      <button
        key={category}
        onClick={() => onCategoryChange(category)}
        className={`px-6 py-2 rounded-full text-sm font-medium transition-all duration-300
          ${activeCategory === category 
            ? 'bg-primary-500 text-white' 
            : 'bg-white/10 text-white hover:bg-white/20'
          }`}
      >
        {category}
      </button>
    ))}
  </div>
);

export default ServiceFilter;